import { render, staticRenderFns } from "./SuspendClientModal.vue?vue&type=template&id=6d108afd"
import script from "./SuspendClientModal.vue?vue&type=script&lang=js"
export * from "./SuspendClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports